import { render, staticRenderFns } from "./PopTableList.vue?vue&type=template&id=5b902503&scoped=true&"
import script from "./PopTableList.vue?vue&type=script&lang=js&"
export * from "./PopTableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b902503",
  null
  
)

export default component.exports